import React from 'react';
import { useAppState } from '../../contexts/AppStateContext';
import { useUi } from '../../contexts/UiContext';
import { inviteLabels } from '../../data/labels';
import { Avatar } from '../Avatar';
export function MembersList() {
  const {
    activeMembers,
    isAdmin,
    viewer
  } = useAppState();
  const {
    openSub
  } = useUi();
  return <div data-id="element-175" data-mp="22fintn5lg8vm">
      <ul className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3" data-id="element-176" data-mp="22fsd18itec09">
        {activeMembers.map(m => {
        const clickable = isAdmin && m.id !== viewer.id;
        const content = <>
              <Avatar member={m} size="lg" data-id="element-177" data-mp="2v4ptr77do0qw" />
              <span className="min-w-0 flex-1 text-left" data-id="element-178" data-mp="2qb4vde1vh4r6">
                <span className="block font-display text-lg font-semibold" data-id="element-179" data-mp="2q9jyvivzzbqo">{m.name}</span>
                <span className="block text-xs text-muted" data-id="element-180" data-mp="2laqy8r1t7f7x">
                  {m.role === 'skrbnik' ? 'Skrbnik' : 'Otrok'} · {inviteLabels[m.invite]}
                </span>
              </span>
            </>;
        return <li key={m.id} data-id="element-181" data-mp="25tes3rl866o9">
              {clickable ? <button type="button" onClick={() => openSub({
            kind: 'member',
            id: m.id
          })} className="flex w-full items-center gap-3 rounded-3xl border-[1.5px] border-line bg-surface p-4 transition-colors duration-150 hover:bg-canvas" data-id="element-182" data-mp="25w18mgq3fwim">
                  {content}
                </button> : <div className="flex items-center gap-3 rounded-3xl border-[1.5px] border-line bg-surface p-4" data-id="element-183" data-mp="210vfoxy9xhl1">{content}</div>}
            </li>;
      })}
      </ul>
      <p className="mt-3 text-xs text-muted" data-id="element-184" data-mp="1r2xs8co8noth">
        Vidiš koledar vseh. Tuj šolski TODO in dnevnik časa vidijo samo član in skrbniki. {isAdmin ? 'Člane urejaš v Nastavitve družine › Člani.' : ''}
      </p>
    </div>;
}